// Author lidongxu
// Date 2023-08-25 16:45:30

class SithMesPrdPpComponent {
    constructor({
                    id = null,
                    operationId = '',
                    reservationNumber = '',
                    reservationItem = '',
                    materialNumber = '',
                    plant = '',
                    batchNumber = '',
                    specialStockIndicator = '',
                    requirementDate = '',
                    requirementQuantit = '',
                    baseUnit = '',
                    isoCode = '',
                    quantityWithdrawn = '',
                    quantity = '',
                    entryUnit = '',
                    unitIsoCode = '',
                    orderNumber = '',
                    movementType = '',
                    itemCategory = '',
                    bomItemNumber = '',
                    sequenceNum = '',
                    operationNumber = '',
                    indicatorBackflush = '',
                    editedStatusText = '',
                    storageLocation = '',
                    salesOrder = '',
                    salesOrderItem = '',
                    finalIssue = '',
                    deleteFlag = '',
                    isSdr = '',
                    po = '',
                    poItem = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.operationId = operationId;
        this.reservationNumber = reservationNumber;
        this.reservationItem = reservationItem;
        this.materialNumber = materialNumber;
        this.plant = plant;
        this.batchNumber = batchNumber;
        this.specialStockIndicator = specialStockIndicator;
        this.requirementDate = requirementDate;
        this.requirementQuantit = requirementQuantit;
        this.baseUnit = baseUnit;
        this.isoCode = isoCode;
        this.quantityWithdrawn = quantityWithdrawn;
        this.quantity = quantity;
        this.entryUnit = entryUnit;
        this.unitIsoCode = unitIsoCode;
        this.orderNumber = orderNumber;
        this.movementType = movementType;
        this.itemCategory = itemCategory;
        this.bomItemNumber = bomItemNumber;
        this.sequenceNum = sequenceNum;
        this.operationNumber = operationNumber;
        this.indicatorBackflush = indicatorBackflush;
        this.editedStatusText = editedStatusText;
        this.storageLocation = storageLocation;
        this.salesOrder = salesOrder;
        this.salesOrderItem = salesOrderItem;
        this.finalIssue = finalIssue;
        this.deleteFlag = deleteFlag;
        this.isSdr = isSdr;
        this.po = po;
        this.poItem = poItem;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesPrdPpComponent();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationId',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.operationId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'reservationNumber',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.reservationNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'reservationItem',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.reservationItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialNumber',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.materialNumber',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'material_bom',
                modalMultiSelectedType: 'string'
                , linkWith: [
                    {field: 'parentMaterialNumber', name: 'parentMaterial'}
                ]
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'netWeight',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.netWeight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'grossWeight',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.grossWeight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dimensions',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.dimensions',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'plant',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.plant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'batchNumber',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.batchNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'specialStockIndicator',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.specialStockIndicator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'requirementDate',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.requirementDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'requirementQuantit',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.requirementQuantit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baseUnit',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.baseUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isoCode',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.isoCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantityWithdrawn',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.quantityWithdrawn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'entryUnit',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.entryUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unitIsoCode',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.unitIsoCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderNumber',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.orderNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'movementType',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.movementType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemCategory',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.itemCategory',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bomItemNumber',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.bomItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sequenceNum',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.sequenceNum',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationNumber',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.operationNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'indicatorBackflush',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.indicatorBackflush',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'editedStatusText',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.editedStatusText',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageLocation',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.storageLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrder',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.salesOrder',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrderItem',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.salesOrderItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'finalIssue',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.finalIssue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deleteFlag',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.deleteFlag',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsCode',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.wbsCode',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isSdr',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.isSdr',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'po',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.po',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItem',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.poItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sdrType',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.sdrType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isBm',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.isBm',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sortString',
            label: 'label.sith.prd.sithMesPrdPpComponent.grid.sortString',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    operationIdFilter: '',
    reservationNumberFilter: '',
    reservationItemFilter: '',
    materialNumberFilter: '',
    plantFilter: '',
    batchNumberFilter: '',
    specialStockIndicatorFilter: '',
    requirementDateRteFilter: '',
    requirementDateLteFilter: '',
    requirementQuantitFilter: '',
    baseUnitFilter: '',
    isoCodeFilter: '',
    quantityWithdrawnFilter: '',
    quantityFilter: '',
    entryUnitFilter: '',
    unitIsoCodeFilter: '',
    orderNumberFilter: '',
    movementTypeFilter: '',
    itemCategoryFilter: '',
    bomItemNumberFilter: '',
    sequenceNumFilter: '',
    operationNumberFilter: '',
    indicatorBackflushFilter: '',
    editedStatusTextFilter: '',
    storageLocationFilter: '',
    salesOrderFilter: '',
    salesOrderItemFilter: '',
    finalIssueFilter: '',
    deleteFlagFilter: '',
    isSdrFilter: '',
    poFilter: '',
    poItemFilter: '',
    isBm: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'operationIdFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.operationId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reservationNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.reservationNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reservationItemFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.reservationItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.materialNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.batchNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialStockIndicatorFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.specialStockIndicator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requirementDateRteFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.requirementDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requirementDateLteFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.requirementDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requirementQuantitFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.requirementQuantit',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseUnitFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.baseUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isoCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.isoCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantityWithdrawnFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.quantityWithdrawn',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'entryUnitFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.entryUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unitIsoCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.unitIsoCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.orderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'movementTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.movementType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCategoryFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.itemCategory',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bomItemNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.bomItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sequenceNumFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.sequenceNum',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.operationNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'indicatorBackflushFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.indicatorBackflush',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'editedStatusTextFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.editedStatusText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocationFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.storageLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.salesOrder',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderItemFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.salesOrderItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finalIssueFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.finalIssue',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deleteFlagFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.deleteFlag',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSdrFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.isSdr',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.stool',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.poItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isBmFilter',
        label: 'label.sith.prd.sithMesPrdPpComponent.filter.isBm',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'operationId',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.operationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reservationNumber',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.reservationNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'reservationItem',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.reservationItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumber',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.batchNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialStockIndicator',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.specialStockIndicator',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requirementDate',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.requirementDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requirementQuantit',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.requirementQuantit',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseUnit',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.baseUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isoCode',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.isoCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantityWithdrawn',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.quantityWithdrawn',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'entryUnit',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.entryUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unitIsoCode',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.unitIsoCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumber',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.orderNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'movementType',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.movementType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCategory',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.itemCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bomItemNumber',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.bomItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sequenceNum',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.sequenceNum',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationNumber',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.operationNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'indicatorBackflush',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.indicatorBackflush',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'editedStatusText',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.editedStatusText',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocation',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.storageLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrder',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.salesOrder',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderItem',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.salesOrderItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finalIssue',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.finalIssue',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deleteFlag',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.deleteFlag',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isSdr',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.isSdr',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'po',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.stool',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItem',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.poItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpComponent.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesPrdPpComponent, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
